import React from 'react';
import './MarriottDigitalHero.css'; // Reusing the same CSS for the layout
import OptimizedImage from './OptimizedImage';

import largeHero from 'url:../../assets-optimized/redesign/solutions/on_property_hero.png';
import largeHeroavif from 'url:../../assets-optimized/redesign/solutions/on_property_hero.avif';
import largeHerowebp from 'url:../../assets-optimized/redesign/solutions/on_property_hero.webp';
import largeHeroMobile from 'url:../../assets-optimized/redesign/solutions/on_property_hero_mobile.png';
import largeHeroMobileavif from 'url:../../assets-optimized/redesign/solutions/on_property_hero_mobile.avif';
import largeHeroMobilewebp from 'url:../../assets-optimized/redesign/solutions/on_property_hero_mobile.webp';

export default function OnPropertyIntro() {
  return (
    <section className='marriott-digital-hero'>
      <div className='md-hero-left'>
        <OptimizedImage
          avif={largeHeroavif}
          webp={largeHerowebp}
          fallback={largeHero}
          mobileAvif={largeHeroMobileavif}
          mobileWebp={largeHeroMobilewebp}
          mobileFallback={largeHeroMobile}
          alt='Hotel lobby with guest room TV display'
          className='md-hero-image'
        />
        <div className='md-hero-left-overlay'>
          <h2 className='md-hero-pill'>
            <span className='no-wrap'>On-property</span> <br className='desktop-only' />
            Experiences
          </h2>
        </div>
      </div>
      <div className='md-hero-right'>
        <h1 className='md-hero-right-title'>
          GUEST <br className='desktop-only' />
          ROOM TECH
        </h1>
        <p className='md-hero-right-statement'>
          <span className='md-hero-bullet' aria-hidden='true' />
          HOW THE JOURNEY IS BEING LIVED IN AND EXPERIENCED
        </p>
      </div>
    </section>
  );
}
